<template>
  <vx-card no-shadow style="min-height:500px;">
    <h2 class="mb-6">Question Config</h2>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Select Type</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <v-select v-if="question" v-model="selectedQuestionType" :options="questionTypeOptions" class="mb-12" />
      </div>
    </div>

    <div v-if="question">
      <question-config-multiple-choice v-if="selectedQuestionType.id === 1" :question="question" />
      <question-config-text-input v-if="selectedQuestionType.id === 2" :question="question" />
      <question-config-media-upload v-if="selectedQuestionType.id === 3" :question="question" />
      <question-config-media-image v-if="selectedQuestionType.id === 4" :question="question" />
      <question-config-media-video v-if="selectedQuestionType.id === 5" :question="question" />
    </div>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button @click="saveConfig" id="save-button" class="ml-auto mt-2">Save Config</vs-button>
    </div>
  </vx-card>
</template>

<script>
import vSelect from 'vue-select'

import QuestionConfigMultipleChoice from "./components/QuestionConfigMultipleChoice.vue";
import QuestionConfigTextInput from "./components/QuestionConfigTextInput.vue";
import QuestionConfigMediaUpload from "./components/QuestionConfigMediaUpload.vue";
import QuestionConfigMediaImage from "./components/QuestionConfigMediaImage.vue";
import QuestionConfigMediaVideo from "./components/QuestionConfigMediaVideo.vue";

export default {
  components: {
    'v-select': vSelect,

    QuestionConfigMultipleChoice,
    QuestionConfigTextInput,
    QuestionConfigMediaUpload,
    QuestionConfigMediaImage,
    QuestionConfigMediaVideo
  },
  props: {
    question: Object
  },
  watch: {
    question: {
      // the callback will be called immediately after the start of the observation
      immediate: true, 
      handler (/*val, oldVal*/) {
        this.selectedQuestionType = this.questionTypeOptions.find(x => x.id === this.question.questionType)
      }
    }
  },
  data () {
    return {
      surveyType: '',
      surveyId: '',
      moduleId: '',
      lessonId: '',
      questionId: '',

      questionTypeOptions: [
        {id: 0, label: 'None'},
        {id: 1, label: 'Multiple Choice'},
        {id: 2, label: 'Text Input'},
        {id: 3, label: 'Media Upload'},
        {id: 4, label: 'Media Image'},
        {id: 5, label: 'Media Video'}
      ],
      selectedQuestionType: {id: 0, label: 'None'},
    }
  },
  methods: {
    saveConfig: function () {
      this.$vs.loading({
        background:'primary',
        color:'#fff',
        container: "#save-button",
        scale: 0.45
      })

      const payload = {
        questionType: this.selectedQuestionType.id,
        configMultipleChoice: this.question.configMultipleChoice,
        configTextInput: this.question.configTextInput,
        configMediaUpload: this.question.configMediaUpload,
        configMediaImage: this.question.configMediaImage,
        configMediaVideo: this.question.configMediaVideo
      }

      this.$http.put(process.env.VUE_APP_API + '/Surveys/' + this.surveyType + '/' + this.surveyId + '/modules/' + this.moduleId + '/lessons/' + this.lessonId + '/questions/' + this.questionId + '/info/config', payload)
          .then(resp => {
            console.log(resp.data);

            this.$vs.notify({
              color:'success',
              title:'Success',
              text:'Question Config saved'
            });
          })
          .catch(err => {
            console.log(err)

            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not save question config: ' + err
            });
          })
          .finally(() => {
            this.$vs.loading.close("#save-button > .con-vs-loading")
          })
    }
  },
  created() {
    this.surveyType = this.$route.params.surveyType;
    this.surveyId = this.$route.params.surveyId;
    this.moduleId = this.$route.params.moduleId;
    this.lessonId = this.$route.params.lessonId;
    this.questionId = this.$route.params.questionId;
  }
}
</script>
